import { observable } from "aurelia-framework";
import { TemperatureScales, TemperatureConverter } from "../../../converters/temperature-value";
import { applicationLogger } from "../../../logging/logger";
import * as moment from "moment";
import { Api } from "../../../services/api";
import { Device } from "../../../models/device";
import { DeviceMeasurementRequestViewModel } from "../../../models/device-measurement-request-view-model";
import { MeasurementViewModel } from "../../../models/measurement-view-model";
import { I18N } from "aurelia-i18n"

export class BaseDeviceChart {
	active: boolean = false;

	device: Device;
	chart: any;

	startDate: string;
	endDate: string;

	min: number;
	max: number;
	step: number;
	@observable days: any;

	chartOptions: any;
	chartData: any;
	@observable isAttached: boolean = false;

	startTimePicker: any;
	showStartTimePicker: boolean = false;

	endTimePicker: any;
	showEndTimePicker: boolean = false;

	rangeSelection: any;

	protected api: Api;
	protected i18n: I18N;

	constructor(api: Api, i18n: I18N) {
		this.api = api;
		this.i18n = i18n;
		this.configureChart();

		this.min = -365;
		this.max = -1;
		this.step = 1;

		this.rangeSelection = [
			{ name: "Day", value: -1 },
			{ name: "Week", value: -7 },
			{ name: "Month", value: -30 },
			{ name: "Year", value: -365 }
		];

		this.days = this.rangeSelection[0];
	}

	daysChanged() {
		if (this.device && this.isAttached) {
			this.getGraphData(this.days.value);
		}
	}

	isAttachedChanged() {
		if (this.device && this.isAttached) {
			this.getGraphData(this.days.value);
		}
	}

	protected bindDevice(device: Device) {
		this.device = device;
		this.configureChartOptions();
		this.configureChartAxes();
		this.getGraphData(this.days);
	}

	private configureChart() {
		this.configureChartOptions();
		this.configureChartAxes();
	}

	protected configureDatasets() {
		// no-op
	}

	protected configureChartAxes() {
		// no-op
	}

	protected configureChartOptions() {
		// no-op
	}

	getTemperatureScale() {
		let scale = localStorage.getItem("temperature-scale");
		if (!scale) {
			scale = TemperatureScales.fahrenheit;
		}
		return scale;
	}

	getTemperatureSymbol(): string {
		let scale = this.getTemperatureScale();
		switch (scale) {
			case TemperatureScales.fahrenheit:
				return "°F";
			case TemperatureScales.celsius:
				return "°C";
			default:
				return "°F";
		}
	}

	convertTemperature(temperature: number) {
		let scale = this.getTemperatureScale();
		switch (scale) {
		case TemperatureScales.celsius:
			return temperature;
		case TemperatureScales.fahrenheit:
			return TemperatureConverter.toFahrenheit(temperature);
		default:
			return TemperatureConverter.toFahrenheit(temperature);
		}
	}

	protected processData(measurements: MeasurementViewModel[]) {
		// no-op
	}

	async onChange(days: number) {
		this.days = days;
		await this.getGraphData(this.days);
	}

	async getData2() {
		const viewModel = new DeviceMeasurementRequestViewModel();
		const end = moment(this.endDate);
		const start = moment(this.startDate);

		viewModel.deviceId = this.device.deviceId;
		viewModel.startDate = new Date(start.toDate().toUTCString());
		viewModel.endDate = new Date(end.toDate().toUTCString());

		await this.getData(viewModel);
	}

	async getData(viewModel: DeviceMeasurementRequestViewModel) {
		// ReSharper restore InconsistentNaming
		this.active = true;
		let response = await this.api.getGraphData(viewModel);

		if (response.success && response.data) {
			this.processData(response.data);
		} else {
			applicationLogger.error(response.message);
		}

		this.active = false;
	}

	async getGraphData(days: number= -1) {
		const end = moment();
		const start = moment().add(moment.duration(days, "day"));
		const viewModel = new DeviceMeasurementRequestViewModel();

		this.startDate = start.format("lll");
		this.endDate = end.format("lll");

		viewModel.deviceId = this.device.deviceId;
		viewModel.startDate = new Date(start.toDate().toUTCString());
		viewModel.endDate = new Date(end.toDate().toUTCString());

		await this.getData(viewModel);

	}

	handleResize(detail) {
		// this.showTip = detail.width < 450;
	}

	showTimePicker(control: string) {
		applicationLogger.info("'showTimePicker' called.");

		switch (control) {
			case "start":
				{
					this.showStartTimePicker = true;
					this.startTimePicker.open();
					break;
				}
			case "end":
				{
					this.showEndTimePicker = true;
					this.endTimePicker.open();
					break;
				}
		}
	}

	hideTimePicker(control: string) {
		applicationLogger.info("'hideDatePicker' called.");
		switch (control) {
			case "start":
				{
					this.showStartTimePicker = false;
				}
			case "end":
				{
					this.showEndTimePicker = false;
				}
		}
	}
}
